<div class="datatable">
  <section class="datatable__actions">
    @if (getSelectedCount() > 0) {
      <p class="datatable__selected-count">
        {{ getSelectedCount() }} ligne(s) sélectionnée(s)
      </p>
      <button
        type="button"
        class="datatable__selected-delete"
        (click)="deleteSelected.emit(getSelectedIds())"
      >
        Supprimer
      </button>
    }
  </section>

  <div
    #tableContainer
    data-slot="table-container"
    class="datatable__container"
    [style.max-height]="
      _mergedConfig().maxHeight
        ? typeof _mergedConfig().maxHeight === 'number'
          ? _mergedConfig().maxHeight + 'px'
          : _mergedConfig().maxHeight
        : '600px'
    "
  >
    <table
      data-slot="table"
      class="datatable__table"
      [style]="_columnSizeVars()"
      [style.min-width.px]="table.getTotalSize()"
    >
      <thead data-slot="table-header" class="datatable__header">
        @for (headerGroup of table.getHeaderGroups(); track headerGroup.id) {
          <tr data-slot="table-row" class="datatable__header-row">
            @for (header of headerGroup.headers; track header.id) {
              <th
                data-slot="table-head"
                class="datatable__head"
                [datatableResizableHeader]="header.id"
                [attr.aria-sort]="header.column.getIsSorted()"
                [attr.colSpan]="header.colSpan"
                [attr.data-pinned]="header.column.getIsPinned() || null"
                [ngStyle]="getCommonPinningStyles(header.column)"
                (click)="handleColumnHeaderClick(header, $event)"
                (dblclick)="handleColumnHeaderDoubleClick(header, $event)"
              >
                @if (!header.isPlaceholder) {
                  <div
                    *flexRender="
                      header.column.columnDef.header;
                      props: header.getContext();
                      let headerContent
                    "
                    (click)="header.column.getToggleSortingHandler()?.($event)"
                    [class.datatable__head-content--sortable]="
                      header.column.getCanSort()
                    "
                    [title]="
                      header.column.getCanSort()
                        ? header.column.getNextSortingOrder() === 'asc'
                          ? 'Trier par ordre croissant'
                          : header.column.getNextSortingOrder() === 'desc'
                            ? 'Trier par ordre décroissant'
                            : 'Effacer le tri'
                        : ''
                    "
                    [attr.aria-sort]="header.column.getIsSorted()"
                    [attr.aria-label]="
                      header.column.getIsSorted() === 'asc'
                        ? 'Trier par ordre croissant'
                        : header.column.getIsSorted() === 'desc'
                          ? 'Trier par ordre décroissant'
                          : 'Effacer le tri'
                    "
                    class="datatable__head-content column-{{
                      header.column.id
                    }}"
                  >
                    <div
                      [innerHTML]="headerContent"
                      class="datatable__head-content__text"
                      [ngClass]="{
                        '!ml-auto': header.column.id === 'actions'
                      }"
                    ></div>

                    @if (_shouldShowSortIndicator(header)) {
                      <span
                        class="datatable__sort-indicator"
                        [attr.data-sort]="header.column.getIsSorted() || 'none'"
                        aria-hidden="true"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          class="datatable__sort-icon"
                        >
                          <path
                            class="datatable__sort-icon-stem datatable__sort-icon-stem--asc"
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 4v16"
                          />
                          <path
                            class="datatable__sort-icon-stem datatable__sort-icon-stem--desc"
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M16 20V4"
                          />
                          <path
                            class="datatable__sort-icon-part datatable__sort-icon-part--asc"
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 8l4-4l4 4"
                          />
                          <path
                            class="datatable__sort-icon-part datatable__sort-icon-part--desc"
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="m20 16l-4 4l-4-4"
                          />
                        </svg>
                      </span>
                    }

                    @if (header.column.id !== 'select') {
                      <button
                        matIconButton
                        #menuTrigger="matMenuTrigger"
                        [matMenuTriggerFor]="columnMenu"
                        class="datatable__head-menu-button"
                        (click)="$event.stopPropagation()"
                        [attr.aria-label]="
                          'Menu de la colonne ' + header.column.id
                        "
                      >
                        <ng-container
                          *ngTemplateOutlet="menuIcon"
                        ></ng-container>
                      </button>
                      <mat-menu #columnMenu="matMenu">
                        @if (header.column.id !== 'actions') {
                          <button
                            mat-menu-item
                            (click)="clearSorting(header)"
                            [disabled]="
                              !header.column.getCanSort() ||
                              !header.column.getIsSorted()
                            "
                          >
                            <span class="!text-13">Effacer le tri</span>
                          </button>
                          <button
                            mat-menu-item
                            (click)="sortAscending(header)"
                            [disabled]="!header.column.getCanSort()"
                          >
                            <span class="!text-13"
                              >Trier par ordre croissant</span
                            >
                          </button>
                          <button
                            mat-menu-item
                            (click)="sortDescending(header)"
                            [disabled]="!header.column.getCanSort()"
                          >
                            <span class="!text-13"
                              >Trier par ordre décroissant</span
                            >
                          </button>
                          <button
                            mat-menu-item
                            (click)="
                              hideColumn(header); $event.stopPropagation()
                            "
                            [disabled]="
                              ['actions', 'select'].includes(
                                header.column.id
                              ) ||
                              !_mergedConfig().enableColumnHiding ||
                              header.column.getCanHide() === false
                            "
                          >
                            <span class="!text-13">Masquer la colonne</span>
                          </button>

                          <mat-divider></mat-divider>
                        }
                        <!-- @if (
                          _mergedConfig().enableColumnPinning &&
                          header.column.getCanPin()
                        ) {
                          <mat-divider></mat-divider>
                          @if (header.column.getIsPinned() !== 'left') {
                            <button
                              mat-menu-item
                              (click)="
                                header.column.pin('left');
                                $event.stopPropagation()
                              "
                            >
                              <span class="!text-13">Épingler à gauche</span>
                            </button>
                          }
                          @if (header.column.getIsPinned()) {
                            <button
                              mat-menu-item
                              (click)="
                                header.column.pin(false);
                                $event.stopPropagation()
                              "
                            >
                              <span class="!text-13">Désépingler</span>
                            </button>
                          }
                          @if (header.column.getIsPinned() !== 'right') {
                            <button
                              mat-menu-item
                              (click)="
                                header.column.pin('right');
                                $event.stopPropagation()
                              "
                            >
                              <span class="!text-13">Épingler à droite</span>
                            </button>
                          }
                        } -->
                        @if (_mergedConfig().enableColumnHiding) {
                          <button
                            mat-menu-item
                            [matMenuTriggerFor]="columnVisibilityMenu"
                            (click)="$event.stopPropagation()"
                          >
                            <span class="!text-13">Gérer les colonnes</span>
                          </button>
                        }
                      </mat-menu>

                      <mat-menu
                        #columnVisibilityMenu="matMenu"
                        class="datatable__column-visibility-menu"
                      >
                        <div
                          class="datatable__column-visibility-menu-content"
                          (click)="$event.stopPropagation()"
                        >
                          <div class="datatable__column-visibility-list">
                            @for (
                              column of table.getAllLeafColumns();
                              track column.id
                            ) {
                              @if (!['actions', 'select'].includes(column.id)) {
                                <div class="datatable__column-visibility-item">
                                  <mat-checkbox
                                    [checked]="isColumnVisible(column.id)"
                                    (change)="
                                      toggleColumnVisibilityById(column.id)
                                    "
                                    (click)="$event.stopPropagation()"
                                  >
                                    <span
                                      class="datatable__column-visibility-label"
                                    >
                                      @if (
                                        typeof column.columnDef.header ===
                                        'string'
                                      ) {
                                        {{ column.columnDef.header }}
                                      } @else {
                                        {{ column.id }}
                                      }
                                    </span>
                                  </mat-checkbox>
                                </div>
                              }
                            }
                          </div>
                        </div>
                      </mat-menu>
                    }
                  </div>
                }

                <!-- Resize handle -->
                @if (header.column.getCanResize()) {
                  <div
                    class="datatable__resizer"
                    [class.datatable__resizer--resizing]="
                      header.column.getIsResizing()
                    "
                    [attr.data-resizing]="header.column.getIsResizing()"
                    (dblclick)="header.column.resetSize()"
                    (mousedown)="header.getResizeHandler()($event)"
                    (touchstart)="header.getResizeHandler()($event)"
                    [attr.aria-label]="
                      header.column.getIsResizing()
                        ? 'Stop resizing'
                        : 'Resize column'
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      class="datatable__resizer-icon"
                    >
                      <path
                        fill="currentColor"
                        d="M11.25 2.75v18.5a.75.75 0 0 0 1.5 0V2.75a.75.75 0 0 0-1.5 0"
                        stroke-width="0"
                        stroke="currentColor"
                      />
                    </svg>
                  </div>
                }
              </th>
            }
          </tr>
        }
      </thead>
      <tbody data-slot="table-body" class="datatable__body">
        @for (row of table.getRowModel().rows; track row.id) {
          <tr
            data-slot="table-row"
            [attr.data-state]="row.getIsSelected() ? 'selected' : null"
            class="datatable__row"
            (click)="handleRowClick(row.original)"
            (dblclick)="handleRowDoubleClick(row.original)"
          >
            @for (cell of row.getVisibleCells(); track cell.id) {
              <td
                #cellRef
                data-slot="table-cell"
                class="datatable__cell"
                [datatableResizableCell]="cell.column.id"
                [attr.data-pinned]="cell.column.getIsPinned() || null"
                [ngStyle]="getCommonPinningStyles(cell.column)"
                (click)="handleCellClick(cell, $event)"
                (dblclick)="handleCellDoubleClick(cell, $event)"
                [matTooltip]="
                  _isTruncated(cellRef)
                    ? getCellTooltipText(cell.getValue())
                    : ''
                "
                [matTooltipDisabled]="!_isTruncated(cellRef)"
                matTooltipShowDelay="300"
              >
                <ng-container
                  *flexRender="
                    cell.column.columnDef.cell;
                    props: cell.getContext();
                    let cellContent
                  "
                >
                  {{ cellContent }}
                </ng-container>
              </td>
            }
          </tr>
        } @empty {
          <datatable-empty [table]="table" />
        }
      </tbody>
    </table>
  </div>
</div>

<ng-template #sortingIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="datatable__icon"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8 20V10m0 10l-3-3m3 3l3-3m5-13v10m0-10l3 3m-3-3l-3 3"
    />
  </svg>
</ng-template>

<ng-template #exportIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2em"
    height="2em"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M4 16.004V17a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1M12 4.5v11m3.5-3.5L12 15.5L8.5 12"
    />
  </svg>
</ng-template>

<ng-template #menuIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12.005 11.995v.01m0-4.01v.01m0 7.99v.01"
    />
  </svg>
</ng-template>
